import Immutable from 'seamless-immutable';
import IntegrationModel from './integration-model';

/**
 * Transforms and array of backend integration objects into a IntegrationCollection
 * @param {Object[]} integrations - backend formatted integrations
 * @returns {Integration[]}
 */
function deserialize(integrations = []) {
  return Immutable(_.map(integrations, IntegrationModel.deserialize));
}

/**
 * Transforms a IntegrationCollection into an array of backend integration objects
 * @param {Integration[]} integrations
 * @returns {Object[]}
 */
function serialize(integrations) {
  return _.map(integrations, integration => IntegrationModel.serialize(integration));
}

export default {
  create: deserialize,
  deserialize,
  serialize,
};
